// Shared shell for marketing sub-pages.
// Provides persistent TopNav + Footer + SignupModal CTA wiring so every
// page (/how-it-works, /pricing, /examples, /testimonials) feels identical.
import TopNav from "@/components/founding/TopNav";
import Footer from "@/components/founding/Footer";
import SignupModal from "@/components/founding/SignupModal";
import LegalDisclaimerModal from "@/components/founding/LegalDisclaimerModal";
import { useFoundingEntry } from "@/hooks/useFoundingEntry";

export default function PageShell({ children }) {
    const { modalOpen, setModalOpen, authMode, setAuthMode, onCtaClick, onSignIn, onSignUp } = useFoundingEntry();
    return (
        <main className="min-h-screen bg-black text-white selection:bg-red-500/30 selection:text-white">
            <TopNav onSignIn={onSignIn} onSignUp={onSignUp} />
            {children}
            <Footer onCtaClick={onCtaClick} />
            <SignupModal
                open={modalOpen}
                onOpenChange={setModalOpen}
                mode={authMode}
                onModeChange={setAuthMode}
            />
            <LegalDisclaimerModal />
        </main>
    );
}
